module.exports = __webpack_public_path__ + "static/media/bible.4e71d70a.svg";